import axios from 'axios';
import * as CONFIG from '../config/index';

export const IP_CONTENT_API_URL = `${CONFIG.API_URL}/ip`;
export const UPDATE_VERSION_API_URL = `${CONFIG.API_URL}/update-version`;
export const REQUEST_UPDATE_VERSION_API_URL = `${UPDATE_VERSION_API_URL}/request`;
export const GET_REQUEST_UPDATE_VERSION_API_URL = `${UPDATE_VERSION_API_URL}/get`;
export const GET_IP_VERSION_API_URL = `${UPDATE_VERSION_API_URL}/get-version`;
export const CONFIRM_UPDATE_VERSION_API_URL = `${UPDATE_VERSION_API_URL}/confirm`;
export const REJECT_UPDATE_VERSION_API_URL = `${UPDATE_VERSION_API_URL}/reject`;
export const SEARCH_UPDATE_VERSION_API_URL = `${UPDATE_VERSION_API_URL}/list`
export const CHECK_IS_UPDATE = `${UPDATE_VERSION_API_URL}/is-update`;

export const getIpContent = async (id) => {
  const {data} = (await axios.get(`${IP_CONTENT_API_URL}/${id}`)).data;

  return {
    id: data.id,
    title: data.title,
    ipType: data.ipType.toString(),
    intro: data.intro,
    guideLine: data.guideLine,
    introVideo: data.introVideo,
    slideShow: data.slideShow,
    attachments: data.attachments,
  }
}

export const requestUpdateVersion = async (form) => {
  await axios.post(`${REQUEST_UPDATE_VERSION_API_URL}`, form)
}

export const getRequestUpdateVersion = async (updateVersionId) => {
  return (await axios.get(`${GET_REQUEST_UPDATE_VERSION_API_URL}?updateVersionId=${updateVersionId}`)).data.data
}

export const getIPVersion = async (contentId) => {
  return (await axios.get(`${GET_IP_VERSION_API_URL}?contentId=${contentId}`)).data.data
}

export const confirmUpdateVersion = async (versionId) => {
  await axios.put(`${CONFIRM_UPDATE_VERSION_API_URL}?versionId=${versionId}`)
}

export const rejectUpdateVersion = async (form) => {
  await axios.put(`${REJECT_UPDATE_VERSION_API_URL}`, form)
}

export const searchUpdateVersion = async (form, pageNo, pageSize) => {
  return (await axios.post(`${SEARCH_UPDATE_VERSION_API_URL}?page=${pageNo - 1}&size=${pageSize}`, form)).data.data
}

export const checkIsUpdateVersion = async (ipContentIds) => {
  if (ipContentIds && ipContentIds.length > 0) {
    const isUpdates = (await axios.get(`${CHECK_IS_UPDATE}?ipContentIds=${ipContentIds.join(",")}`)).data.data
    const isUpdateDict = {}
    for (let {ipContentId, isUpdate} of isUpdates) {
      isUpdateDict[ipContentId] = isUpdate
    }
    return isUpdateDict;
  }
  return {};
}



// WEBPACK FOOTER //
// ./src/common/updateVersion.js